<header class="lk-eu-header">
  <div
    class="grid grid-nogutter justify-content-center flex-nowrap w-full"
    style="height: 100%">
    <div class="xl:col-8 md:col-10 col-11">
      <div class="flex flex-nowrap justify-content-between align-items-center pl-2">
        <div class="flex flex-nowrap align-items-center gap-3">
          <img
            src="assets/images/favicon.png"
            style="height: 50px; width: 50px" />

          <p-menubar
            [model]="menuItems"
            styleClass="lk-eu-menubar"></p-menubar>
        </div>

        <div class="flex flex-nowrap align-items-center gap-4">
          <div>
            <crm-lk-eu-notification-icon [(isShow)]="isShow"></crm-lk-eu-notification-icon>
          </div>

          <div
            class="lk-eu-profile"
            routerLink="/lk/external-user/settings">
            <div class="flex flex-nowrap align-items-center gap-2">
              <div>
                <h4 class="text-right mb-0">{{ authService.currentProfile?.name }}</h4>
                <p class="text-sm text-right">{{ authService.currentUser?.job }}</p>
              </div>

              <div>
                <crm-user-avatar
                  [user]="authService.currentProfile"
                  shape="circle"
                  size="xlarge"></crm-user-avatar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<div class="lk-eu-body pt-3">
  <crm-lk-eu-notification-panel></crm-lk-eu-notification-panel>
  <div
    class="grid grid-nogutter justify-content-center flex-nowrap w-full"
    style="height: 100%">
    <div class="xl:col-8 md:col-10 col-11">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<crm-lk-eu-notification-sidebar [(isShow)]="isShow"></crm-lk-eu-notification-sidebar>

<crm-form-sidebar></crm-form-sidebar>
